import axios from "axios";
import router from "../router/index";

const LOGIN_ENDPOINT = "/api/auth/jwt/create/";
const ME_ENDPOINT = "/api/auth/users/me/";
const REGISTER_ENDPOINT = "/api/account/register/";
const RESETPASSWORD_ENDPOINT = "/api/account/resetpassword/";
const CHANGEPASSWORD_ENDPOINT = "/api/account/changepassword/";
const USERACCESSDATA_ENDPOINT = "/api/customizeaccess/useraccessdetails/";

/* Setting default auth header for all request through request interceptor*/

axios.interceptors.request.use(function(config) {
  // dot net API not working for peelhunt that's why we add this code.
  config.withCredentials = false;
  let token = null;
  let afterLoginToken = window.sessionStorage.getItem("auth_token");
  if (!afterLoginToken) {
    if (window.location.href.includes("auth_token=")) {
      let iframeToken = window.location.href
        .split("/")
        .filter(function(el) {
          if (el.includes("auth_token=")) return true;
        })[0]
        .split("=")[1];
      if (iframeToken) {
        token = iframeToken;
      }
    }
  } else {
    if (afterLoginToken) {
      token = afterLoginToken;
    }
  }
  // dot net API not working for peelhunt that's why we add this code.
  if (!config.url.includes("peelhuntdotnet")) {
    config.headers.Authorization =
      typeof token != "undefined" && token != "" && token != null
        ? "JWT " + token
        : "";
  } else {
    // if url match
    if (window.location.pathname === "/fs/peelHuntCont/") {
      const urlParams = new URLSearchParams(window.location.search);
      const entries = urlParams.entries(); //returns an iterator of decoded [key,value] tuples
      const queryParameterObj = {};
      for (const [key, value] of entries) {
        // each 'entry' is a [key, value] tupple
        queryParameterObj[key] = value;
      }
      token = queryParameterObj.AuthToken;
      token = window.atob(token);
      // const params = paramsToObject(entries);
      config.headers.AuthToken =
        typeof token != "undefined" && token != "" && token != null
          ? "Bearer " + token
          : "";
      // as per client requirement,
      let UniqueImprint = queryParameterObj.UniqueImprint;
      // let URL = queryParameterObj.urlPath;
      config.headers.UniqueImprint = UniqueImprint;
      // config.headers.urlPath = URL;
    }
  }
  return config;
});
/*axios.interceptors.request.use(function(config) {
  const token = "JWT " + window.sessionStorage.getItem("auth_token");
  config.headers.Authorization = token;
  return config;
});*/
/* Setting response intersecptor for server idle session timeout*/
axios.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  (error) => {
    /* 401 Unauthorized error*/
    if (
      error.response.status === 401 &&
      !Object.keys(error.response.data).includes("detail")
    ) {
      router.push({ name: "logout" });
    }
    /* No further process for any other error*/ return Promise.reject({
      ...error,
    });
  }
);

export default {
  login(data) {
    return axios.post(
      `${process.env.VUE_APP_CONTEXTPATH}${LOGIN_ENDPOINT}`,
      data
    );
  },
  getUserProfile() {
    return axios.get(`${process.env.VUE_APP_CONTEXTPATH}${ME_ENDPOINT}`);
  },
  register(data) {
    return axios.post(
      `${process.env.VUE_APP_CONTEXTPATH}${REGISTER_ENDPOINT}`,
      data
    );
  },
  resetpassword(data) {
    let token = JSON.parse(JSON.stringify(data.token));
    delete data.token;
    delete data.confirmPassword;
    delete data.id;
    // window.sessionStorage.setItem("auth_token", data.token);
    // data.token = "";
    return axios.post(
      `${process.env.VUE_APP_CONTEXTPATH}${RESETPASSWORD_ENDPOINT}` +
        `${token}/`,
      data
    );
  },
  changepassword(data) {
    return axios.post(
      `${process.env.VUE_APP_CONTEXTPATH}${CHANGEPASSWORD_ENDPOINT}`,
      data
    );
  },
  userAccessData(user) {
    return axios.get(
      `${process.env.VUE_APP_CONTEXTPATH}${USERACCESSDATA_ENDPOINT}${user.id}/`
    );
  },
  iframe(data) {
    return axios.get(
      `${process.env.VUE_APP_DOMAIN_URL}${process.env.VUE_APP_IFRAME_ENDPOINT}${data.url}/`
    );
  },
};
